export { StatisticsView } from "../../components/reports/statistics-view";
